import { Component, OnInit } from '@angular/core';

import { Device } from '../devices/device.model';
import { DeviceService } from '../devices/device.service';

import { Organization } from '../organization/organization.model';
import { OrganizationService } from '../organization/organization.service';

import { Location } from '../locations/location.model';
import { LocationService } from '../locations/location.service';

import { NotificationService } from '../shared/notification/notification.service';
import { LoadingService } from '../shared/loading/loading.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  public addedDevices: number[] = [];
  public nextId: number;
  public provisionComplete: boolean = false;

  constructor(
    public deviceService: DeviceService,
    public notificationService: NotificationService,
    public organizationService: OrganizationService,
    public locationService: LocationService,
    public loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.deviceService.getNextId().subscribe((id) => {
      if (id) this.nextId = id;
    });
  }

  provision() {
    this.loadingService.loading = true;
    this.deviceService.provisionDevices()
      .subscribe((devices) => {
        if (devices && Array.isArray(devices)) {
          devices.forEach((device) => {
            this.deviceService.addDevice(device);
            this.addedDevices.push(device.id);
          })

          this.loadingService.loading = false;
          this.notificationService.success(`${devices.length} devices created!`, 3000);
          this.provisionComplete = true;
        }
      });
  }

  saveDevice(device) {
    this.deviceService.saveDevice(device);
  }

}
